import { useEffect, useState } from "react";
import { Select } from "@mantine/core";
import { get, post } from "./Request.jsx";
import { useUser } from "../tools/Context";

export default function Footer() {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const { token, email, setUserData } = useUser();
  const { isratp } = useUser();

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await get("users", null, token);
        setUsers(response);
        if (email) {
          const currentUser = response.find((user) => user.email === email);
          if (currentUser) {
            setSelectedUser(currentUser.id);
          }
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    fetchUsers();
  }, [token, email]);

  const handleUserChange = async (value) => {
    const selectedUser = users.find((user) => user.id === value);
    if (selectedUser) {
      const response = await post(
        "login",
        {
          email: selectedUser.email,
          password: selectedUser.password,
        },
        token
      );
      setUserData(response.id, response.token, response.role, selectedUser.email, response.isratp); // Update the user context
      setSelectedUser(value);
    }
  };

  return (
    <>
      {isratp && (
        <Select
          w={200}
          placeholder="Select a user"
          data={users.map((user) => ({
            value: user.id,
            label: user.email,
          }))}
          value={selectedUser}
          onChange={handleUserChange}
        />
      )}
    </>
  );
}
